var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "hotel-block",
      class: { "hotel-loading": _vm.hotel.loading }
    },
    [
      _c("hotel-block-header", {
        attrs: { hotel: _vm.hotel, "force-favorite": _vm.isFavoriteItem },
        on: {
          titleclick: _vm.readMore,
          addFavorite: _vm.onAddFavorite,
          showrating: _vm.onShowRating
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hotel-block__image", on: { click: _vm.readMore } },
        [
          _c("transition", { attrs: { name: "image-transition" } }, [
            _c("span", { style: { "background-image": _vm.hotelImg } })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "hotel-block__description" },
        [
          _c("transition", { attrs: { name: "description-transition" } }, [
            _c("span", { domProps: { textContent: _vm._s(_vm.description) } })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.dateFrom || _vm.dateTo
        ? _c("div", { staticClass: "hotel-travel-dates" }, [
            _c("span", {
              staticClass: "hotel-travel-dates__from",
              domProps: { textContent: _vm._s(_vm.dateFrom) }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "hotel-travel-dates__arrow",
              attrs: {
                src: require("./../../../img/icons/icon-travel-date-arrow.svg"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "hotel-travel-dates__from",
              domProps: { textContent: _vm._s(_vm.dateTo) }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hotel.totalPrice
        ? _c("total-price", {
            attrs: {
              "total-price": _vm.hotel.totalPrice,
              currency: _vm.hotel.currency
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hotel.id
        ? _c(
            "button",
            { staticClass: "btn btn--positive", on: { click: _vm.readMore } },
            [
              _c("span", { staticClass: "btn__icon btn__icon--left" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 28.08 28.08"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M21.22,2.62l-3,3L3.54,3.33,0,6.86l13,4L7.78,16.06H2.12L0,18.18,7.78,20.3,9.9,28.08,12,26V20.3l5.24-5.23,4,13,3.53-3.53L22.49,9.83l3-3C27.8,4.53,28.75,1.67,27.58.5S23.55.29,21.22,2.62Z"
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "btn__text",
                domProps: { textContent: _vm._s(_vm.translations.more_info) }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "btn__icon btn__icon--right" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 27.01 26.01"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M26.13,10.88l-10-10a3,3,0,1,0-4.25,4.24L16.76,10H3a3,3,0,0,0,0,6H16.76l-4.88,4.88a3,3,0,0,0,4.25,4.25l10-10A3,3,0,0,0,27,13,3,3,0,0,0,26.13,10.88Z"
                      }
                    })
                  ]
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d939adc", { render: render, staticRenderFns: staticRenderFns })
  }
}